import styled from 'styled-components';

export const Container = styled.div`
  display: none;
  @media (max-width: 850px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 2rem 1rem;
    z-index: 0;
    background: var(--gray-background);
    border-top: 0px;
    gap: 0.5rem;


    #images-start {
      display: flex;
      gap: .5rem;
      img {
        max-width: 80px;
        height: 35px;
      }
    }

    #text-middle {
      font-size: .7rem;
      line-height: 1.5;
      max-height: 100px;
      overflow: none;
      text-align: justify;
      text-overflow: ellipsis;  
    }

    #text-end {
      font-size: 0.9rem;
      text-align: end;
      white-space: nowrap;
      display: flex;
      gap: 0.5rem;
    }
  }

  @media (max-width: 720px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 2rem 1rem;
    z-index: 0;
    background: var(--gray-background);
    border-top: 0px;
    gap: 0.5rem;

    #images-start {
      display: flex;
      gap: .5rem;
      img {
        max-width: 80px;
        height: 35px;
      }
    }

    #text-middle {
      font-size: .7rem;
      line-height: 1.5;
      max-height: 100px;
      overflow: none;
      text-align: justify;
      text-overflow: ellipsis;  
    }

    #text-end {
      font-size: 0.9rem;
      text-align: end;
      white-space: nowrap;
      display: flex;
      gap: 0.5rem;
    }
  }

`;


